import { Fragment } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import styles from '../BookingLocation.scss';
import { BookingContext, bookingClassNameModifier } from '../../booking.context';

export const MapImage = ({ imageSrc, searchQuery }) => (
  <BookingContext.Consumer>
    {(context) => (
      <Fragment>
        {imageSrc !== null ? (
          <a
            className={styles[`${bookingClassNameModifier(context)}BookingReview__map`]}
            href={`https://maps.google.com/maps?${qs.stringify({ q: searchQuery })}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {imageSrc && <img src={imageSrc} alt="map" />}
          </a>
        ) : (
          <div className={styles[`${bookingClassNameModifier(context)}BookingReview__empty`]}>
            <p>Map unavailable at this time</p>
          </div>
        )}
      </Fragment>
    )}
  </BookingContext.Consumer>
);

MapImage.propTypes = {
  imageSrc: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
};
